import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

// images
import ubxLogo from '../images/train-icon 1.svg'

// styles
const useStyles = makeStyles({
  divider: {
    display: 'flex',
    alignItems: 'center',
  },
  border: {
    height: 1,
    background: '#DEDEDE',
    flexGrow: 1,
  },
  iconContainer: {
    padding: '0 0.625rem',
  },
})

function Divider({ icon = <img src={ubxLogo} alt="" /> }) {
  const classes = useStyles()
  return (
    <div className={classes.divider}>
      <div className={classes.border} />
      <div className={classes.iconContainer}>{icon}</div>
      <div className={classes.border} />
    </div>
  )
}

export default Divider
